<div  style="background-image: url('assets/images/Vector.png'); min-height: 100vh;background-color: rgba(35, 113, 211, 0.03);">
    <div class="heading-top bg-white d-flex pb-0">
        <div class="h6 font-weight-bold pt-1 sm-22 mr-5">
          <!-- <i class="fa fa-money pr-2 pl-0 primary-text"></i> -->
          <svg class="mr-2 pt-1"  width="22" height="22" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.14284 6.22928C4.43563 6.61441 4.89811 6.83221 5.3815 6.81262C6.14084 6.81262 6.75684 6.35062 6.75684 5.78128C6.75684 5.21195 6.14084 4.75062 5.3815 4.75062C4.62217 4.75062 4.00684 4.28862 4.00684 3.71862C4.00684 3.14862 4.62284 2.68728 5.3815 2.68728C5.8649 2.66769 6.32737 2.88549 6.62017 3.27062" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.38135 6.81274V7.50008" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.38135 2V2.68733" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15.5002 13.9907L14.5068 12.5V9C14.5068 7.66667 11.9735 6.24067 11.0068 5.5" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.2935 9.86267L9.86155 7.91334C9.52226 7.57405 8.97217 7.57405 8.63288 7.91334C8.2936 8.25263 8.2936 8.80272 8.63288 9.14201L10.9882 11.8V13.4667C10.9882 14.254 12.1135 15.4967 12.1135 15.4967" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.00684 15.5H1.42284C0.916835 15.4996 0.506836 15.0893 0.506836 14.5833V1.41667C0.506836 0.910666 0.916835 0.500368 1.42284 0.5H10.0895C10.5959 0.5 11.0065 0.910298 11.0068 1.41667V8.83133" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.00684 9.5H3.00684C2.73069 9.5 2.50684 9.72386 2.50684 10V13C2.50684 13.2761 2.73069 13.5 3.00684 13.5H9.00684" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.50684 11.5H8.00684" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5.50684 9.5V13.5" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Pay a bill
        </div>
        <div class="sendMoney-timeline" style="margin-left: 20%;">
            <ul class="timeline m-0 pt-1 px-5" id="timeline">
                <li class="li complete">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Bill </p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete' : billerService.details}">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Details</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete' : billerService.confirm}">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Confirm</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete' : billerService.complete}">
                    <div class="status pl-0 px-3 border-0">
                        <p class="sm-12 m-neg color-royalblue border-0">Complete</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
<router-outlet></router-outlet>
</div>
